<div
  class="card-item-list-item"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + card().header"
>
  <div class="card-item-list-item-inner">
    <div class="card-item-list-item-image" [style.background]="card().image ? null : gradient()">
      @if (card().image) {
        <ptl-card-image [src]="card().image" [alt]="card().header" [cardIndex]="cardIndex()"></ptl-card-image>
      }
    </div>

    <div class="card-item-list-item-content">
      @if (card().v3CardType || card().collectionType) {
        <span class="card-item-list-type-badge" [ngClass]="typeColorClass()">{{ typeDisplayName() }}</span>
      }
      <h3 class="card-item-list-item-title">{{ card().header }}</h3>
    </div>

    <div class="card-item-list-progress-ring" [attr.aria-label]="progress() + '% complete'">
      <svg width="46" height="46" viewBox="0 0 46 46" style="transform: rotate(-90deg); flex-shrink: 0; display: block">
        <circle cx="23" cy="23" [attr.r]="RING_RADIUS" fill="none" stroke="var(--rule)" stroke-width="4"></circle>
        <circle
          cx="23"
          cy="23"
          [attr.r]="RING_RADIUS"
          fill="none"
          stroke="var(--accent)"
          stroke-width="4"
          [attr.stroke-dasharray]="progressArc()"
          stroke-linecap="round"
        ></circle>
        <text
          x="50%"
          y="50%"
          text-anchor="middle"
          dominant-baseline="middle"
          class="ring-text"
          style="transform: rotate(90deg); transform-origin: center center"
        >
          {{ progress() }}%
        </text>
      </svg>
    </div>
  </div>
</div>
